<template>
  <div class="all-shop">
    <div class="container">
      <div class="category-card">
        <div class="row">
          <div class="col-lg-2 col-md-12 category-border-right">
              <div class="category-card-title">
                  <h2>{{category.title}}</h2>
                  <div class="category-card-list">
                      <ul>
                          <li v-for="(item,i) in category.list" :key="i">
                              <router-link :to="item.link">{{item.listitem}}</router-link>
                          </li>
                      </ul>
                  </div>
              </div>
          </div>
          <div class="col-lg-10 col-md-12">
            <div class="category-content">
              <div class="col-lg-10">
                <div class="row">
                  <div class="col-md-3 col-sm-6" v-for="(item,i) in productCard.data" :key="i">
                    <div class="single-offer-product">
                      <div class="offer-img">
                        <img :src="item.img" alt="feature-logo">
                      </div>
                      <div class="offer-txt">
                        <div class="quick-icon">
                          <router-link :to="item.content.details"><i class="fa fa-search"></i> </router-link>
                          <router-link :to="item.content.details"> <i class="fa fa-heart-o"></i> </router-link>
                        </div>
                        <h2 class="pName">
                          <router-link :to="item.content.details">{{item.content.title}}</router-link>
                        </h2>
                        <p>{{item.content.offerPrice}} <del>{{item.content.oldPrice}}</del></p>
                        <router-link class="addCart" :to="item.content.link">
                          <i class="fa fa-shopping-cart"></i> {{item.content.btn}}
                        </router-link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data(){
      return {
        category:{
          title: 'electricity',
          list: [
              {listitem:'computer',link:'/computer'},
              {listitem:'laptop',link:'/laptop'}
          ]
          },
        productCard: {
          data: [
            {
              img : "https://bit.ly/2Tp8nZB",
              content : {
                title      : "dummy title",
                details    : "/product/id",
                offerPrice : "$125.00",
                oldPrice   : "",
                btn        :  "add to cart",
                link       :  "/"
              }
            },
            {
              img : "https://bit.ly/2Uh8XGe",
              content : {
                title      : "dummy title",
                details    : "/product/id",
                offerPrice : "$125.00",
                oldPrice   : "",
                btn        :  "add to cart",
                link       :  "/"
              }
            },
            {
              img : "https://bit.ly/2Uh8XGe",
              content : {
                title      : "dummy title",
                details    : "/product/id",
                offerPrice : "$125.00",
                oldPrice   : "$250.00",
                btn        :  "add to cart",
                link       :  "/"
              }
            },
            {
              img : "https://bit.ly/2VwFMz4",
              content : {
                title      : "dummy title",
                details    : "/product/id",
                offerPrice : "$125.00",
                oldPrice   : "$250.00",
                btn        :  "add to cart",
                link       :  "/"
              }
            },
            {
              img : "https://bit.ly/2Tp8nZB",
              content : {
                title      : "dummy title",
                details    : "/product/id",
                offerPrice : "$125.00",
                oldPrice   : "",
                btn        :  "add to cart",
                link       :  "/"
              }
            },
            {
              img : "https://bit.ly/2Uh8XGe",
              content : {
                title      : "dummy title",
                details    : "/product/id",
                offerPrice : "$125.00",
                oldPrice   : "",
                btn        :  "add to cart",
                link       :  "/"
              }
            }
          ]
        }
      }
    }
  }
</script>


<style>
  .all-shop{
    padding: 60px 0;
  }
  .all-shop .single-offer-product {padding: 0!important;margin-bottom: 30px;}

</style>
